export const ASSETS_URL = 'https://assets.internal.logixboard.com'
export const LOGOS = `${ASSETS_URL}/logos`

export const LXB_COLOR = '#2CC3AD'
